import OrderRecoveryScreen from './components/OrderRecoveryScreen';
import OrderAttentionAlert from './components/OrderAttentionAlert';
import UploadStorageAlert from './components/UploadStorageAlert';
import Tracking from './pages/Tracking';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './auth';
import Header from './components/Header';
import Footer from './components/Footer';
import Terms from './pages/Terms';
import ProtectedRoute from './components/ProtectedRoute';
import ItemList from './pages/ItemList';
import ItemDetail from './pages/ItemDetail';
import Login from './pages/Login';
import Signup from './pages/Signup';
import OwnerDashboard from './pages/OwnerDashboard';
import PropertyForm from './pages/PropertyForm';
import MyVisits from './pages/MyVisits';
import AgentDashboard from './pages/AgentDashboard';
import AdminDashboard from './pages/AdminDashboard';
import Account from './pages/Account';
import Pricing from './pages/Pricing';
import ChangePassword from './pages/ChangePassword';
import PasswordGate from './components/PasswordGate';
import SubscriptionGate from './components/SubscriptionGate';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Header />
        <div className="container"><UploadStorageAlert /><OrderAttentionAlert /></div>
        <div className="container pb-5">
          <PasswordGate>
          <SubscriptionGate>
          <Routes>
            <Route path="/order-recovery/:caseId" element={<ProtectedRoute roles={['owner', 'admin']}><OrderRecoveryScreen /></ProtectedRoute>} />
            <Route path="/tracking" element={<ProtectedRoute><Tracking /></ProtectedRoute>} />
            <Route path="/" element={<ItemList />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/items/:id" element={<ItemDetail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/owner"
              element={
                <ProtectedRoute roles={['owner']}>
                  <OwnerDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/owner/properties/new"
              element={
                <ProtectedRoute roles={['owner']}>
                  <PropertyForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/owner/properties/:id/edit"
              element={
                <ProtectedRoute roles={['owner']}>
                  <PropertyForm />
                </ProtectedRoute>
              }
            />
            {/* admin_real_estate_property_management.md - the website owner edits any listing
                (details, specs, site address, photos) or adds a new one, reusing PropertyForm. */}
            <Route
              path="/admin/properties/new"
              element={
                <ProtectedRoute roles={['admin']}>
                  <PropertyForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/properties/:id/edit"
              element={
                <ProtectedRoute roles={['admin']}>
                  <PropertyForm />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-visits"
              element={
                <ProtectedRoute roles={['customer']}>
                  <MyVisits />
                </ProtectedRoute>
              }
            />
            <Route
              path="/agent"
              element={
                <ProtectedRoute roles={['delivery']}>
                  <AgentDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                // Owner Bookings & Cancellation v2 doc, "New roles" - the 3 finance_* roles land
                // on AdminDashboard's Finance tab (it self-gates the admin-only tabs internally),
                // so they need to clear this route guard too, not just admin.
                <ProtectedRoute roles={['admin', 'finance_employee', 'finance_lead', 'finance_manager']}>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account"
              element={
                <ProtectedRoute>
                  <Account />
                </ProtectedRoute>
              }
            />
            <Route
              path="/account/password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<ItemList />} />
          </Routes>
          </SubscriptionGate>
          </PasswordGate>
        </div>
        <Footer />
      </AuthProvider>
    </BrowserRouter>
  );
}
